// DryWeatherForm.jsx
import { useState, useEffect } from "react"
import { UniversalDropDown } from "@fileops/swmm-react"
import { Button } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Dry Weather Form is a group of data inputs usually shown when clicking on Node->Inflows. 
 * This form is contained within InflowsDialog.
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {string} target The name of the node targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function DryWeatherForm({model, setModel, fullModel, target}) {
  const [constituent, setConstituent] = useState('FLOW')
  const [constituents]                = useState(["FLOW", ...(Object.keys(fullModel.POLLUTANTS).length===0?[]:Object.keys(fullModel.POLLUTANTS))])
  const [patterns]                    = useState([        ...(Object.keys(fullModel.PATTERNS  ).length===0?[]:Object.keys(fullModel.PATTERNS  ))])

  useEffect(()=>{
    // If there is no DWF record for this constituent, for this target, create one
    if(model && model.DWF){
      if(!(constituent in model.DWF[target])){
        setModel(prev => ({
          ...prev,
          DWF:{
            ...prev.DWF,
            [target]: {
              ...prev.DWF[target],
              [constituent]: {
                Base: "0",
                Pat1: '',
                Pat2: '',
                Pat3: '',
                Pat4: '',
              }
            }
          }
        }))
      }
    }
  }, )
  
  // When there is a change to an input element, modify the model.
  const updateValue = (val, type) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ""

    if(model && model.DWF){
      setModel(prev => ({
        ...prev,
        DWF:{
          ...prev.DWF,
          [target]: {
            ...prev.DWF[target],
            [constituent]: {
              ...prev.DWF[target][constituent],
              [type]: val
            }
          }
        }
      }))
    }
  }

  return(
    <>
    {
      <>
        {(
          target && 
          target.length > 0 && 
          model.DWF &&
          model.DWF[target] &&
          model.DWF[target][constituent] &&
          <label className='editor-small' >Constituent
            <UniversalDropDown style={{padding: '0'}}
              IDs={constituents} 
              selectText={"Select a Constituent"} 
              value={constituent}
              onChange={(val)=>{setConstituent(val)}} >
            </UniversalDropDown>
          </label>
        )}
        {(
          target && 
          target.length > 0 && 
          model.DWF &&
          model.DWF[target] &&
          model.DWF[target][constituent] &&
          <label className='editor-small' >Average Value
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateValue(e.target.value, 'Base')}}
                    value={model.DWF[target][constituent].Base}
                    id={'AverageValue_'+target}
            />
          </label>
        )}
        {(
          target && 
          target.length > 0 && 
          model.DWF &&
          model.DWF[target] &&
          model.DWF[target][constituent] &&
          <label className='editor-small' >Time Pattern 1
            <Button style={{padding: '0px', float:'right', display:'inline' }}  onClick={()=>{updateValue('', 'Pat1')}}>CLEAR</Button>
            <UniversalDropDown style={{padding: '0'}}
              IDs={patterns} 
              selectText={"Select a Pattern"} 
              value={model.DWF[target][constituent].Pat1}
              onChange={(val)=>{updateValue(val, 'Pat1')}} >
            </UniversalDropDown>
          </label>
        )}
        {(
          target && 
          target.length > 0 && 
          model.DWF &&
          model.DWF[target] &&
          model.DWF[target][constituent] &&
          <label className='editor-small' >Time Pattern 2
            <Button style={{padding: '0px', float:'right', display:'inline' }}  onClick={()=>{updateValue('', 'Pat2')}}>CLEAR</Button>
            <UniversalDropDown style={{padding: '0'}}
              IDs={patterns} 
              selectText={"Select a Pattern"} 
              value={model.DWF[target][constituent].Pat2}
              onChange={(val)=>{updateValue(val, 'Pat2')}} >
            </UniversalDropDown>
          </label>
        )}
        {(
          target && 
          target.length > 0 && 
          model.DWF &&
          model.DWF[target] &&
          model.DWF[target][constituent] &&
          <label className='editor-small' >Time Pattern 3
            <Button style={{padding: '0px', float:'right', display:'inline' }}  onClick={()=>{updateValue('', 'Pat3')}}>CLEAR</Button>
            <UniversalDropDown style={{padding: '0'}}
              IDs={patterns} 
              selectText={"Select a Pattern"} 
              value={model.DWF[target][constituent].Pat3}
              onChange={(val)=>{updateValue(val, 'Pat3')}} >
            </UniversalDropDown>
          </label>
        )}
        {(
          target && 
          target.length > 0 && 
          model.DWF &&
          model.DWF[target] &&
          model.DWF[target][constituent] &&
          <label className='editor-small' >Time Pattern 4
            <Button style={{padding: '0px', float:'right', display:'inline' }}  onClick={()=>{updateValue('', 'Pat4')}}>CLEAR</Button>
            <UniversalDropDown style={{padding: '0'}}
              IDs={patterns} 
              selectText={"Select a Pattern"} 
              value={model.DWF[target][constituent].Pat4}
              onChange={(val)=>{updateValue(val, 'Pat4')}} >
            </UniversalDropDown>
          </label>
        )}
      </>
    }
    </>
  )
}